import React, { useEffect, useState } from 'react';
import MainLayout from '../../layouts/main/MainLayout';
import TrimModal from '../../components/TrimModal/TrimModal';
import useFileStore from '../../store/fileStore';

import useTrimStore from '../../store/trimStore';
import * as S from './Trim.style';

const Trim = () => {
  const { files, loadFiles } = useFileStore();
  const [loading, setLoading] = useState(false);

  // const  {clearTreeStates} = useTrimStore();

  useEffect(() => {
    // 컴포넌트 마운트시 파일 목록 로드
    loadFiles();
  }, [loadFiles]);

  const handleRefresh = () => {

    // clearTreeStates();
    // console.log('[TRIM_MODAL]', '🔥 트리 상태 초기화 완료');
    loadFiles();
    console.log('[Trim]', 'Refreshing loadFiles');
  };

  // 파일 목록을 TrimModal이 기대하는 형식으로 변환
  const availableFiles = files.map(file => ({
    id: file.file_id,
    name: file.filename
  }));

  return (
    <MainLayout>

        <S.PageHeader>
          <S.HeaderTop>
            <div>
              <S.PageTitle>데이터 관리</S.PageTitle>
              <S.PageSubtitle>
                필요한 변수를 특정하여 sub-dataset을 생성합니다
              </S.PageSubtitle>
            </div>
            {/* <S.HeaderActions>
              <S.RefreshButton onClick={handleRefresh} disabled={loading}>
                🔄 새로고침
              </S.RefreshButton>
            </S.HeaderActions> */}
          </S.HeaderTop>
        </S.PageHeader>

      <S.ContentSection>
        <TrimModal availableFiles={availableFiles} />
      </S.ContentSection>
    </MainLayout>
  );
};

export default Trim;